import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Standalone pipeline run detail route (`/pipeline-runs/$runId`). Like the
 * pipeline detail page, it lives outside the Integrations layout so the run
 * view is a full page with no tab rail. Super-admin only.
 */
const PipelineRunDetailPage = lazy(
  () => import('~/features/integrations/pages/pipeline-run-detail-page'),
);

// Declares the shared subsidiary scope (`sc`) so a run belonging to a picked,
// non-active subsidiary can be read here. Undeclared params are stripped on
// navigation, which is what made those runs 404 on this page.
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/pipeline-runs/$runId')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

/** Reads the route param and renders the lazy page inside the page-gradient shell. */
function RouteComponent() {
  const { runId } = Route.useParams();
  return (
    <div className="bg-gradient-page min-h-full p-6">
      <Suspense fallback={<PageSkeleton />}>
        <PipelineRunDetailPage runId={runId} />
      </Suspense>
    </div>
  );
}
